import * as React from "react";
import { useMatch } from "react-router";

const IsBackofficeContext = React.createContext<boolean | undefined>(undefined);

const useIsBackoffice = () => {
    const isMatch = useMatch("/bo/*");
    return !!isMatch;
};

type Props = {
    children?: React.ReactNode;
};

const IsBackofficeProvider = ({ children }: Props) => {
    const isBackoffice = useIsBackoffice();
    return (
        <IsBackofficeContext.Provider value={isBackoffice}>
            {children}
        </IsBackofficeContext.Provider>
    );
};

const useIsBackofficeContext = () => {
    const context = React.useContext(IsBackofficeContext);
    if (context === undefined) {
        throw new Error(
            "useIsBackofficeContext must be used within a IsBackofficeContext",
        );
    }
    return context;
};

export { IsBackofficeProvider, useIsBackoffice, useIsBackofficeContext };
